import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import leftArrow from "../../../images/leftArrowF.svg";

export default function CustomTooltip(props) {
  const { tooltipProps, step, primaryProps, index } = props;

  const history = useHistory();

  const handleNext = (event) => {
    primaryProps.onClick(event);
  };

  useEffect(() => {
    if (index === 1) {
      history.push("/posts");
    } else if (index === 2) {
      history.push("/deals");
    } else if (index === 3) {
      history.push("/event");
    } else if (index === 4) {
      history.push("/business-profile");
    } else if (index === 5) {
      history.push("/dashboard");
    } else if (index === 6) {
      window.location.reload();
    }
  });

  return (
    <div
      onClick={handleNext}
      className={`bg-transparent w-96 flex flex-row tour-row items-start pr-3 cursor-pointer`}
      {...tooltipProps}
    >
      <img className="-mt-6 -ml-3" src={leftArrow} alt="arrow" />
      <h2 className={`text-white text-lg font-bold`}>{step.content}</h2>
    </div>
  );
}
